module.exports = __webpack_public_path__ + "img/icon-network-error.3bc274ab.png";